import React, { useEffect, useState } from "react";
import { ConfigProvider } from "antd";
import NetworkError from "./components/NetworkError";
import { helpers, storage } from "./services";
import i18next from "i18next";
import config from "./config";
import Actions from "./store/actions";
import { Modal } from "./components";
import ModulesActions from "@/modules/entity/actions";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash/get";

import "./App.scss";

const App = ({ children }) => {
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);
  const profile = useSelector((state) => get(state.auth, "user"));
  const branches = useSelector((state) =>
    get(state.system, "organizations", []),
  );
  const showChangeOrganizationModal = useSelector(
    (state) => state.system.showChangeOrganizationModal,
  );

  const storageToken = storage.get("token");

  const [selectOrganizationModal, showSelectOrganizationModal] = useState(
    false,
  );
  const [selectedOrgId, setSelectedOrgId] = useState(null);
  const [isSubmitting, setSubmitting] = useState(false);

  const setLanguage = () => {
    const savedLang = storage.get("language");

    if (helpers.isEnableLang(savedLang)) {
      dispatch(Actions.system.ChangeLanguage(savedLang));
      i18next.changeLanguage(savedLang);
    } else {
      dispatch(Actions.system.ChangeLanguage(config.DEFAULT_LANGUAGE));
      i18next.changeLanguage(config.DEFAULT_LANGUAGE);
    }
  };

  const handleSubmitSetOrganization = () => {
    if (!selectedOrgId) return;

    setSubmitting(true);

    dispatch(
      ModulesActions.FormDefault.request({
        url: "/user/update-me",
        method: "put",
        values: {
          organization_id: selectedOrgId,
        },
        cb: {
          success: () => {},
          error: () => {},
          finally: () => {
            window.location.reload();
          },
        },
      }),
    );
  };

  useEffect(() => {
    if (showChangeOrganizationModal) {
      showSelectOrganizationModal(true);

      const content = document.querySelector(".devent-content");
      if (content) {
        content.style.filter = "blur(60px)";
      }

      const currentOrgId = get(profile, "organization_id");
      if (currentOrgId) {
        setSelectedOrgId(currentOrgId);
      } else {
        setSelectedOrgId(null);
      }
    }
  }, [showChangeOrganizationModal, profile]);

  useEffect(() => {
    if (storageToken) {
      dispatch(Actions.auth.GetMe());
      dispatch(Actions.system.GetUnits());
      dispatch(Actions.system.GetPaymentTypes());
    }

    setLanguage();
  }, []);

  const closeOrganizationModal = () => {
    showSelectOrganizationModal(false);
    setSelectedOrgId(null);

    const content = document.querySelector(".devent-content");
    if (content) {
      content.style.filter = "none";
    }

    dispatch(Actions.system.ToggleOrganizationModal(false));
  };

  const token = storageToken || get(auth, "token");
  const mockData = { isFetched: true, isAuthenticated: false, data: null };

  return (
    <ConfigProvider theme={{ token: { zIndexPopupBase: 1100 } }}>
    <div>
      <div
        className={`blur-backdrop ${selectOrganizationModal ? "--active" : ""}`}
      />

      <Modal
        width={920}
        isOpen={selectOrganizationModal}
        backdrop={false}
        closeIcon={!!get(profile, "organization_id")}
        toggle={closeOrganizationModal}
      >
        <div className="organization-select-modal">
          <div className="organization-select-modal__header">
            <h3 className="organization-select-modal__title">Выберите точку</h3>
            <p className="organization-select-modal__subtitle">
              Выберите филиал, в котором сейчас работаете. Это повлияет на
              отчёты, склад и кассу.
            </p>
          </div>

          <div className="organization-select-modal__list-wrapper">
            {branches.length === 0 && (
              <div className="organization-select-modal__empty">
                Филиалы не найдены. Обратитесь к администратору системы.
              </div>
            )}

            {branches.length > 0 && (
              <div className="organization-select-modal__list">
                {branches.map((org) => (
                  <button
                    type="button"
                    key={org.id}
                    className={
                      "organization-select-modal__item" +
                      (selectedOrgId === org.id
                        ? " organization-select-modal__item--active"
                        : "")
                    }
                    onClick={() => setSelectedOrgId(org.id)}
                  >
                    <span className="organization-select-modal__radio">
                      <span className="organization-select-modal__radio-inner" />
                    </span>

                    <div className="organization-select-modal__item-content">
                      <span className="organization-select-modal__item-title">
                        {org.name}
                      </span>
                    </div>
                  </button>
                ))}
              </div>
            )}
          </div>

          <div className="organization-select-modal__footer">
            <button
              type="button"
              className={
                "d-btn d-btn--full d-btn-primary" +
                (isSubmitting ? " --loading" : "")
              }
              onClick={handleSubmitSetOrganization}
              disabled={isSubmitting || !selectedOrgId}
            >
              {isSubmitting ? "Переходим..." : "Перейти"}
            </button>
          </div>
        </div>
      </Modal>

      <NetworkError />
      <div id="custom-alert-zone" />

      {children(token ? auth : mockData)}
    </div>
    </ConfigProvider>
  );
};

export default App;
